// context for when drawer is fully open and minimized

import { createContext } from 'react';

export const DrawerOpenContext = createContext(null);